// extracted by mini-css-extract-plugin
module.exports = {"modal":"KeepAliveModal_modal__2y8j3"};